// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","pageBtn":"Pagination_pageBtn__kuck2","navBtn":"Pagination_navBtn__GfnrI","active":"Pagination_active__DDld0"};